
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137.8 86.1c-34.1 2.2-54.8 9.7-70.5 25.5-9.3 9.4-16.1 22.8-19.8 38.8-7.4 32.8-2.5 48.6 24.3 78.9C83.1 242.2 85 245.9 85 256s-1.9 13.8-13.2 26.7c-16.4 18.5-23.4 30.4-26.4 44.3-1.9 9.2-1.3 19.2 2.1 34.6 6.7 29.4 23.3 48.4 50 57.3 22.2 7.4 36.3 8.1 158.5 8.1 123.2 0 136.6-.7 159.2-8.4 12.9-4.4 19.7-8.5 28.9-17.7 6.5-6.4 8.5-9.2 12.7-18 5.5-11.4 8.6-22.4 10.4-36.6 2.6-21.5-4.4-38.1-27-63.7-11.3-12.8-13.2-16.5-13.2-26.6s1.9-13.8 13.2-26.6c22.6-25.6 29.6-42.2 27-63.7-1.8-14.2-4.9-25.2-10.4-36.6-4.2-8.8-6.2-11.6-12.7-18-9.2-9.2-16-13.3-28.9-17.7-12.4-4.2-23.6-6.1-43.7-7.4-18.8-1.2-214.8-1.1-233.7.1M299 152c0 21.7.2 24.4 1.9 27.8 8.5 16.6 31.5 16 38.5-1 1.3-3 1.6-8.3 1.6-27.3V128h11.8c34.7 0 55.9 5.2 63.3 15.6 5.3 7.3 10 25.7 8.5 33.5-.9 4.8-7 13.7-17.1 24.9-4.7 5.2-10.2 11.9-12.1 14.8-15 22.4-15 56 0 78.4 1.9 2.9 7.4 9.6 12.1 14.8 10.1 11.2 16.2 20.1 17.1 24.9 1.5 7.8-3.2 26.2-8.5 33.5-7.4 10.3-28.9 15.6-63.3 15.6H341v-24c0-21.7-.2-24.4-1.9-27.8-8.3-16.2-29.9-16.2-38.2 0-1.7 3.4-1.9 6.1-1.9 27.8v24h-75.7c-78.3 0-93.5-.6-107-4-14.4-3.7-21.1-9.4-25.3-21.3-2.6-7.5-4.5-19.4-3.6-23.8.9-4.8 7-13.7 17.1-24.9 4.7-5.2 10.2-11.9 12.1-14.8 15-22.4 15-56 0-78.4-1.9-2.9-7.4-9.6-12.1-14.8-10.1-11.2-16.2-20.1-17.1-24.9-.4-1.9-.2-6.7.4-10.5 3.5-21.9 10.2-29.9 28.9-34.6 13.1-3.3 23.3-3.7 104.6-3.9l77.7-.1z"}}),_c('path',{attrs:{"d":"M315 213.9c-7.4 2.4-11.9 6.3-14.5 12.3-1.2 3.1-1.5 8.5-1.5 29.8s.3 26.7 1.5 29.8c6.4 15.2 27.3 17.2 37 3.4l3-4.4.3-26.6c.4-28.6 0-32-4.5-37.2-4.8-5.7-15.1-9.1-21.3-7.1"}})])
          )
        }
      }
    